import React,{useState} from 'react';
import {Col, Row, Layout, Divider} from 'antd';


const headerStyle: React.CSSProperties = {
    color: '#090909ff',
    lineHeight: '25px',
    backgroundColor: '#fff',
    paddingLeft: '0px',
    paddingRight: '0px',
};
const dividerStyle: React.CSSProperties = {
    margin: '15px',
};

interface PriceItem {
    weightRange: string;
    unit: string;
    price: string;
}
const ItemRowView : React.FC<{
       priceItem:PriceItem
    }> = ({priceItem}) => {
    return (
        <Col span={16} offset={4}>
            <Row justify="center" gutter={[14,0]}>
                <Col span={16}>
                    <Row>
                        <Col span={8}>
                            <span>任意一个大于</span>
                        </Col>
                        <Col span={2}>
                            <span></span>
                        </Col>
                        <Col span={14}>
                            <span>{priceItem.weightRange} {priceItem.unit}</span>
                        </Col>
                    </Row>
                </Col>
                <Col span={8}>
                    <Row>
                        <Col span={9}>
                            <span>{priceItem.price}</span>
                        </Col>
                        <Col span={8}>
                            <span>美金</span>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Col>
    );
}

interface PriceCardViewData {
    groupName: string;
    priceItems: PriceItem[];
}

/**
 * 定价卡片组件
 */
const PriceCard: React.FC<{
     cardViewData: PriceCardViewData;
}> = ({cardViewData}) => {
        const { Header, Sider, Content } = Layout;
        return (
            <Layout style={{backgroundColor:'#fff', padding:15, border:'1px solid #e8e8e8', borderRadius:5}}>
                <Header style={headerStyle}>
                    <Row justify="center" align='middle'>
                        <Col span={10} >
                            <span>Weight/重量</span>
                        </Col>
                        <Col span={6} >
                            <span>Price/价格</span>
                        </Col>
                    </Row>
                    <Divider style={dividerStyle} />
                </Header>
                <Layout>
                    <Content style={{ background: '#fff'}}>
                        <Row justify="start" gutter={[0, 7]}>
                            {cardViewData.priceItems.map((row, index) => (
                                <ItemRowView 
                                    key={index}
                                    priceItem={row}
                                />
                            ))}
                        </Row>
                    </Content>
                </Layout>
            </Layout>
        );
    };

/**
    超重费Tabb组件
 */
const OverWeightFeeViewTab: React.FC<{renderData:any, priceCardView?:PriceCardViewData[]}> = ({renderData,priceCardView = []}) => {
    // 将renderData转换为PriceCardViewData[]类型
        const convertedData: PriceCardViewData[] = React.useMemo(() => {
            if (!renderData || !Array.isArray(renderData)) {
                return priceCardView;
            }
            
            try {
                return renderData.map((item: any) => ({
                    groupName: item.groupName || '',
                    priceItems: Array.isArray(item.priceItems) 
                        ? item.priceItems.map((priceItem: any) => {
                            // 构建重量范围字符串：startWeight - endWeight
                            const weightRange = priceItem.weightOrVolumeWeight;
                            
                            // 获取单位，并添加中文说明
                            const unit = priceItem.weightOrVolumeWeightUnit === 'oz' 
                                ? 'oz/盎司' 
                                : priceItem.weightOrVolumeWeightUnit === 'lb' 
                                ? 'lb/英磅' 
                                : priceItem.weightOrVolumeWeightUnit === 'kg'
                                ? 'kg/千克'
                                : '';
                            
                            // 格式化价格
                            const price = priceItem.priceUsd !== undefined 
                                ? priceItem.priceUsd.toString() 
                                : '';
                            
                            return {
                                weightRange,
                                unit,
                                price
                            };
                        })
                        : []
                }));
            } catch (error) {
                console.error('Error converting renderData:', error);
                return priceCardView;
            }
        }, [renderData, priceCardView]);
    
        // 优先使用转换后的数据，如果转换结果为空则使用priceCardView
        const displayData = convertedData.length > 0 ? convertedData : priceCardView;
    
        return (
            <div>
                {displayData.map((card, index) => (
                    <div key={index} style={{ marginBottom: index !== displayData.length - 1 ? 15 : 0 }}>
                        <PriceCard 
                            cardViewData={card} 
                        />
                    </div>
                ))}
            </div>
        );
}

export default OverWeightFeeViewTab;